import isNode from '../modules/ajio-util/isNode';

const getJioAdsHeader = (userAgent, isMsite) => {
  return {
    ua: isNode() ? userAgent : window.navigator.userAgent,
    ai: 'www.ajio.com',
    os: isMsite ? '3' : '4',
    vr: 'WEB-1.15.0'
  };
};

const jioAdsShowOnPageLoad = (firebaseFlag, entities) => {
  if (!firebaseFlag || !entities) {
    return false;
  }
  const productArray = Object.values(entities);
  return productArray.some((product = {}) => {
    const { adsData = {} } = product;
    return !!adsData.ad;
  });
};

const fireAddTrackers = (entities, trackerType) => {
  try {
    const { JioAds } = window;
    if (JioAds) {
      entities.forEach(entity => {
        const {
          code: productID,
          adsize = '',
          productOptions = '',
          adsData = {},
          fnlColorVariantData = {}
        } = entity;
        const { colorGroup = '' } = fnlColorVariantData;
        const trackerJson = adsData.ad;
        if (trackerJson) {
          JioAds.fireAdsTracker(
            adsData,
            trackerType,
            colorGroup || productID,
            adsize,
            productOptions
          );
        }
      });
    }
  } catch (error) {
    console.log('Failed to fireAdsTracker', error);
  }
};

const userDetailsEvent = userdetails => {
  try {
    const { JioAds } = window;
    if (JioAds) {
      JioAds.userDetailsEvent(userdetails);
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', userdetails);
  }
};

const deeplinkLaunchEvent = () => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK deeplinkLaunchEvent jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        deeplinkLaunchEvent();
      }, 1000);
      return;
    } else if (JioAds) {
      let url = window?.location?.href || '';
      const isDeeplink = window?.location?.href.includes("utm_source");
      console.log("🚀 ~ file: jioAds.js:67 ~ deeplinkLaunchEvent ~ isDeeplink:", isDeeplink)
      if(!isDeeplink) return;
      const searchParams = new URLSearchParams(window.location.search);
      let sourceData = searchParams.get('utm_source');
      console.log("🚀 ~ file: jioAds.js:72 ~ deeplinkLaunchEvent ~ sourceData:", sourceData)
      let deepLinkEvent = {
        deeplinkUri : url, 
        "firstLaunch": 1, 
        referrerApp: sourceData
      }
      console.log("TRACK DEEPLINK JIO ADS SDK CALLLING......... ~ deepLinkEvent:", deepLinkEvent)
      JioAds.deeplinkLaunchEvent(deepLinkEvent);
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', deepLinkEvent);
  }
};

const jioAdsAppLaunchEvent = () => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS EVENT jioAdsAppLaunchEvent FUNCTION CALLED jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsAppLaunchEvent();
      }, 1000);
      return;
    } else if (JioAds) {
      console.log("TRACK JIO ADS EVENT jioAdsAppLaunchEvent FUNCTION EVENT FINAL CALLING........");
      JioAds.appLaunchEvent({"firstLaunch": 1})
    }
  } catch (error) {
    console.log('Failed to app launch');
  }
};

const jioAdsCartViewEvent = cartItems => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS CART VIEW EVENT ~ : jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsCartViewEvent(cartItems);
      }, 1000);
      return;
    } else if (JioAds) {
      console.log("TRACK JIO ADS CART VIEW EVENT  ~ JIO ADS CALLING............", cartItems)
      const productList = cartItems.map(product => {
        const {
          brickCategory: segment,
          brickName: brickname,
          baseProduct: id,
          brickSubCategory: vertical,
          basePrice = {},
          quantity = 1,
          totalPrice = {},
          sku = ''
        } = product;
        const { value = 0 } = basePrice;
        return {
          segment,
          vertical,
          brickname,
          id,
          sku,
          price: totalPrice?.value,
          quantity
        };
      });
      console.log("TRACK JIO ADS CART VIEW EVENT ~ productList:", productList)
      let cartViewEvent = {
        "startTime": "",
        "endTime": "",
        "productDetails": {
          "currency": "INR",
          "productList": productList
        }
      }
      console.log("🚀 ~ file: jioAds.js:117 ~ jioAdsCartViewEvent ~ cartViewEvent:", cartViewEvent)
      JioAds.cartViewEvent(cartViewEvent)
    }
  } catch (error) {
    console.log('Failed to cartView Event', error);
  }
};

const jioAdsPageViewEvent = ( page = "wishlistpage" ) => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS PAGE EVENT : jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsPageViewEvent(page);
      }, 1000);
      return;
    } else if (JioAds) {
      console.log("TRACK JIO ADS PAGE EVENT............", page)
      let pageViewEvent = {
        "pageName": page, //: "Homepage/wishlistpage/cartpage
        "startTime": "",
        "endTime": ""
       } 
       JioAds.pageViewEvent(pageViewEvent)
    }
  } catch (error) {
    console.log('Failed to page view Event', error);
  }
};

const jioAdsProductListViewEvent = (entities, facets) => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK PRODUCT LIST FUNCTION : jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsProductListViewEvent(entities, facets);
      }, 1000);
      return;
    } else if (JioAds) {
      const entityList = Object.values(entities);
      console.log("TRACK PRODUCT LIST FUNCTION CALLED")
      const productList = entityList.map(product => {
        const {
          segmentNameText: segment,
          brickNameText: brickname,
          code: id,
          verticalNameText: vertical,
          price = {}
        } = product;
        const { value = 0 } = price;
        return {
          segment,
          vertical,
          brickname,
          id,
          price: value,
          quantity: 1
        };
      });
      const searchParams = new URLSearchParams(window.location.search);
      let query = searchParams.get('query');
      let queryData = query?.split(":") || [];
      let filter = facets?.currentFacets?.results || [];
      let filterListArray = [];
      if(queryData?.length > 0) {
        filterListArray = queryData.map((field, indexValue) => {
          let index = filter.indexOf(field);
          if(index > -1){
            return {
              name : field,
              value : queryData[indexValue + 1] || ''
            }
          } else {
            return null;
          }
        })
      }
      let filterList = filterListArray.filter(data => data);
      console.log("TRACK PRODUCT LIST FUNCTION CALLED ~ filterList:", filterList)
      let productListViewEvent = {
        "startTime": "",
        "endTime": "",
        "productDetails": {
          "listName": "",
          "currency": "INR",
          "productList": productList,
          "filters": filterList
        },
      }
      console.log("🚀 ~ file: jioAds.js:207 ~ jioAdsProductListViewEvent ~ productListViewEvent:", productListViewEvent)
      JioAds.productListViewEvent(productListViewEvent)
    }
  } catch (error) {
    console.log('Failed to product list Event', error);
  }
};

const jioAdsLocationEvent = locationEventData => {
  console.log("TRACK JIO ADS LOCATION VIEW EVENT ~ locationEventData:", locationEventData)
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS LOCATION VIEW EVENT ~ locationEventData: jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsLocationEvent(locationEventData);
      }, 1000);
      return;
    } else if (JioAds) {
      const {
        cartItems,
        locationDetails : {
          pincode = '',
          lat = '',
          lon = ''
        }
      } = locationEventData;
      const productList = cartItems.map(product => {
        const {
          brickCategory: segment,
          brickName: brickname,
          baseProduct: id,
          brickSubCategory: vertical,
          basePrice = {},
          quantity = 1,
          totalPrice = {},
          sku = ''
        } = product;
        const { value = 0 } = basePrice;
        return {
          segment,
          vertical,
          brickname,
          id,
          sku,
          price: totalPrice?.value,
          quantity
        };
      });
      console.log("TRACK JIO ADS LOCATION VIEW EVENT ~ productList:", productList)
      let locationViewData = {};
      if(pincode?.length > 0){
        locationViewData = {
          pincode,
          productDetails : {
            currency: 'INR',
            productList: productList
          }
        }
      } else if(lat && lon) {
        locationViewData = {
          lat : lat.toString(),
          lon : lon.toString(),
          productDetails : {}
        }
      }
      console.log("TRACK JIO ADS LOCATION VIEW EVENT ~ locationViewData:", locationViewData)
      JioAds.locationEvent(locationViewData)
    }
  } catch (error) {
    console.log('Failed to product list Event', error);
  }
}

const jioAdsAddtoCart = ({
  brickCategory: segment,
  brickSubCategory: vertical,
  brickName: brickname,
  code: id,
  price,
  quantity
}) => {
  try {
    const { JioAds } = window;
    if (JioAds) {
      const productDetails = {
        currency: 'INR',
        productList: [
          {
            segment,
            vertical,
            brickname,
            id,
            price,
            quantity
          }
        ]
      };
      console.log("TRACK POINT 3 ~ productDetails:", productDetails)
      JioAds.addtoCart({ productDetails });
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', error);
  }
};

const jioAdsRemoveFromCart = ({
  brickCategory: segment,
  brickSubCategory: vertical,
  brickName: brickname,
  code: id,
  price,
  quantity
}) => {
  console.log("TRACK JIO ADS OBSERVATION POINT 5 : FUNCTION CALLED .........");
  try {
    const { JioAds } = window;
    if (JioAds) {
      const productDetails = {
        currency: 'INR',
        productList: [
          {
            segment,
            vertical,
            brickname,
            id,
            price,
            quantity
          }
        ]
      };
      console.log("TRACK JIO ADS OBSERVATION POINT 5 : JIO ADS CALLING .........", productDetails);
      JioAds.removeFromCart({ productDetails });
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', error);
  }
};

const jioAdsAddtoWishList = ({
  brickCategory: segment,
  brickSubCategory: vertical,
  brickName: brickname,
  code: id,
  price,
  quantity
}) => {
  try {
    const { JioAds } = window;
    if (JioAds) {
      const productDetails = {
        currency: 'INR',
        productList: [
          {
            segment,
            vertical,
            brickname,
            id,
            price,
            quantity
          }
        ]
      };
      console.log("TRACK POINT 3 ~ productDetails:", productDetails)
      JioAds.addtoWishList({ productDetails });
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', error);
  }
};

const jioAdsRemoveFromWishList = ({
  brickCategory: segment,
  brickSubCategory: vertical,
  brickName: brickname,
  code: id,
  price,
  quantity
}) => {
  try {
    const { JioAds } = window;
    if (JioAds) {
      const productDetails = {
        currency: 'INR',
        productList: [
          {
            segment,
            vertical,
            brickname,
            id,
            price,
            quantity
          }
        ]
      };
      console.log("TRACK POINT 3 ~ productDetails:", productDetails)
      JioAds.removeFromWishList({ productDetails });
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', error);
  }
};

const jioAdsProductViewEvent = ({ productDetails }) => {
  console.log("TRACK JIO ADS OBSERVATION POINT 4 : FUNCTION CALLED .........", productDetails);
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS OBSERVATION POINT 4 jioAdsProductViewEvent : jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsProductViewEvent({ productDetails });
      }, 1000);
      return;
    } else if (JioAds) {
      console.log("TRACK JIO ADS OBSERVATION POINT 4 : JIO ADS CALLING .........", productDetails);
      JioAds.productViewEvent({ productDetails });
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', { productDetails });
  }
};

const jioAdsPurchaseCompleted = order => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS OBSERVATION POINT 4 jioAdsProductViewEvent : jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsPurchaseCompleted(order);
      }, 1000);
      return;
    } else if (JioAds) {
      console.log("TRACK JIO ADS OBSERVATION POINT 6  ~ JIO ADS CALLING............", productList)
      const { id: orderId, item } = order;
      const productList = item.map(product => {
        const {
          brickCategory: segment,
          brickName: brickname,
          baseProduct: id,
          brickSubCategory: vertical,
          basePrice = {},
          quantity = 1,
          totalPrice = {}
        } = product;
        const { value = 0 } = basePrice;
        return {
          segment,
          vertical,
          brickname,
          id,
          price: value,
          quantity
        };
      });
      const purchaseEvent = {
        transactionId: orderId,
        productDetails: {
          currency: 'INR',
          productList
        }
      };
      console.log("TRACK jioAdsPurchaseCompleted ~ purchaseEvent:", purchaseEvent)
      JioAds.purchaseCompleted(purchaseEvent);
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', error);
  }
};

const jioAdsSearchViewEvent = (entities, searchString = '') => {
  try {
    const { JioAds, jioSDKInitializedStatus = "NOTYET" } = window;
    console.log("TRACK JIO ADS OBSERVATION POINT 4 jioAdsProductViewEvent : jioSDKInitializedStatus", jioSDKInitializedStatus);
    if(JioAds && jioSDKInitializedStatus !== "DONE"){
      setTimeout(() => {
        jioAdsSearchViewEvent(entities, searchString);
      }, 1000);
      return;
    } else if (JioAds) {
      const productArray = Object.values(entities);
      const productList = productArray.map(entity => {
        const { code: id, price, fnlColorVariantData = {} } = entity;
        const { colorGroup = '' } = fnlColorVariantData;
        const { value = 0 } = price;
        return {
          id: colorGroup || id,
          price: value,
          quantity: 1
        };
      });
      const searchDetails = {
        searchString,
        currency: 'INR',
        productList
      };
      JioAds.searchViewEvent({ searchDetails });
    }
  } catch (error) {
    console.log('Failed to userDetailsEvent', error);
  }
};

export {
  getJioAdsHeader,
  jioAdsShowOnPageLoad,
  fireAddTrackers,
  userDetailsEvent,
  deeplinkLaunchEvent,
  jioAdsAddtoCart,
  jioAdsRemoveFromCart,
  jioAdsAddtoWishList,
  jioAdsRemoveFromWishList,
  jioAdsProductViewEvent,
  jioAdsPurchaseCompleted,
  jioAdsSearchViewEvent,
  jioAdsAppLaunchEvent,
  jioAdsCartViewEvent,
  jioAdsPageViewEvent,
  jioAdsProductListViewEvent,
  jioAdsLocationEvent,
};
